import { Injectable } from '@angular/core';
import { ActionService } from './action.service';
import { LocaleService } from './locale.service';
import { AppState } from '../../../store';
import { Store } from '@ngrx/store';
import { BookPickupComponent } from '../../pickup/book-pickup/book-pickup.component';
import { ActionEnum } from '../../../enum/action.enum';
import { Action } from '../../../models/action';
import { Observable } from 'rxjs';
import { CancelPickupComponent } from '../../pickup/cancel-pickup/cancel-pickup.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
    providedIn: 'root'
})
export class PickupBookingService {

    constructor(private actionService: ActionService, private snackbar: MatSnackBar, private localeService: LocaleService,
                private dialog: MatDialog, private store: Store<AppState>) {
    }

    openPickupBookingShipments(selection: string[]): void {
        this.dialog.open(BookPickupComponent, { data: { selectedShipments: selection }});
    }

    bookPickupForShipments(shipmentIds: string[], date: string, readyTime: string, closeTime: string, parameters: {}): Observable<Action> {
        return this.actionService.sync(ActionEnum.PICKUP_BOOK, [], {
            shipmentIds, date, readyTime, closeTime, parameters
        });
    }

    openPickupCancel(pickupIds: string[]): void {
        this.dialog.open(CancelPickupComponent, { data: { selectedPickups: pickupIds }});
    }

    cancelPickups(pickupIds: string[]): Observable<Action> {
        return this.actionService.sync(ActionEnum.PICKUP_CANCEL, pickupIds);
    }
}
